module.exports = __webpack_public_path__ + "static/media/birch-not-selected.1e5e51ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tags/birch-not-selected.svg
// module id = 67
// module chunks = 0